import type { Resource } from '../../';
export const account_createAccount_title: Resource = {"default":"Create Account"};
